// tslint:disable
export var CampaignStreamType;
(function (CampaignStreamType) {
    // UNKN
    CampaignStreamType[CampaignStreamType["UNKN"] = 10001] = "UNKN";
    // INT
    CampaignStreamType[CampaignStreamType["INT"] = 10002] = "INT";
    // EVT
    CampaignStreamType[CampaignStreamType["EVT"] = 10003] = "EVT";
})(CampaignStreamType || (CampaignStreamType = {}));
//# sourceMappingURL=CampaignStreamType.js.map